// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useCallback, useEffect, useState } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Table } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { getTransactionLedger } from '../../../services/OrdersService';
import TransactionRow from './TransactionRow';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const TransactionLedger = ({ orderId, tz }) => {
  const [transactionLedgerApiStatus, setTransactionLedgerApiStatus] = useState(
    'loading'
  );
  const [transactions, setTransactions] = useState([]);

  const fetchTransactionLedger = useCallback(async () => {
    try {
      const fetchedTransactionLedger = await getTransactionLedger(orderId);
      setTransactions(fetchedTransactionLedger);
      setTransactionLedgerApiStatus('success');
    } catch {
      setTransactionLedgerApiStatus('error');
    }
  }, []);

  useEffect(() => {
    fetchTransactionLedger();
  }, []);

  if (transactionLedgerApiStatus === 'loading') {
    return <div>Loading transactions...</div>;
  }

  if (transactionLedgerApiStatus === 'error') {
    return <div>An error occurred while loading transaction ledger.</div>;
  }

  if (transactions.length === 0) {
    return <div>There are no transactions associated with this order.</div>;
  }

  return (
    <Table responsive>
      <thead>
        <tr>
          <th>Transaction Type</th>
          <th>Amount</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {transactions.map(transaction => (
          <TransactionRow
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            key={transaction.id}
            transaction={transaction}
            tz={tz}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default TransactionLedger;
